/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    assetTreeId: {}
  },
  getters: {
    assetTreeId: state => state.assetTreeId
  },
  mutations: {
    assetTreeId: (state, data) => {
      state.assetTreeId = data
    }
  },
  actions: {
    handleAssetTreeId (assetTreeId, data) {
      assetTreeId.commit('assetTreeId', data)
    }
  }
}
